import React, { useEffect, useState, useContext } from "react";
import SmallLoader from "../../common/SmallLoader";
import { createPricingSummaryTable } from "../sections-quote/pricing-tool/utils/utils";
import DatePicker from "react-datepicker";
import moment from "moment";
import { isExistingBusiness } from "../../../utils/fieldAccess";
import { LibertateContext } from "../../../context/Context";

import { Form } from "react-bootstrap";

const PricingTableSummary = ({
  styles,
  sutaTypeMap,
  data,
  pricingTablesummaryDataLoader,
  selectedCarrier,
  proposalNumber,
  updateProposalNumber,
  editedCompanyNameViewProposal,
  setEditedCompanyNameViewProposal,
  editedquoteGenratedDate,
  seteditedquoteGenratedDate,
  companyNameError,
  disabled,
  setSignaturePersonInfo,
  signatureNamesDB,
}) => {
  let initialQuoteDate = moment
    .unix(editedquoteGenratedDate / 1000)
    .format("MM/DD/YYYY");
  let newDate = new Date(initialQuoteDate);
  const [newDateee, setNewDatee] = useState(null);

  const handleDateChange = (date) => {
    if (date) {
      const year = date.getFullYear();
      if (year.toString().length <= 4) {
        setNewDatee(date);
        seteditedquoteGenratedDate(date);
      } else {
        // Optionally, handle the situation (e.g., alert the user)
        console.warn("Year must be four digits.");
      }
    }
  };

  const handleDateInputChange = (e) => {
    if (!e?.target) return; // Exit if event or target is undefined
    const rawData = e.target.value || "";
    const data = rawData.replace(/[^\d/]/g, ""); // allow digits and slashes only
    const digit = data.replace(/\D/g, "").slice(0, 8);

    let autoFormat = "";
    for (let i = 0; i < digit.length; i++) {
      // auto slashing
      if (i === 2 || i === 4) autoFormat += "/";
      autoFormat += digit[i];
    }
    const isValidFormat = /^(\d{0,2}(\/\d{0,2}(\/\d{0,4})?)?)?$/.test(data); // formating the input
    const formattedValue = isValidFormat ? data : autoFormat;
    e.target.value = formattedValue.slice(0, 10);
    if (formattedValue.length === 10) {
      const m = moment(formattedValue, "MM/DD/YYYY", true);
      if (m.isValid()) {
        // final validation
      }
    }
  };

  return (
    <>
      <div>
        <div className="d-flex justify-content-between mt-5 mb-3">
          <h5 className="fw-bold">Pricing Summary</h5>
        </div>

        {!pricingTablesummaryDataLoader && (
          <div className="d-flex align-items-center my-4  gap-5 w-100 pricingsummaryinpts">
            <p className="  d-flex align-items-center">
              <b className="mx-1">Quote Date : </b>
              <DatePicker
                disabled={disabled}
                selected={newDate}
                onChange={handleDateChange}
                showYearDropdown
                showMonthDropdown
                useShortMonthInDropdown
                dateFormat="MM/dd/yyyy"
                onChangeRaw={handleDateInputChange}
                wrapperClassName="flex-grow-1"
              />
            </p>
            <p className="d-flex align-items-center  flex-grow-1">
              <b className="mx-1">Pricing Indication created for :</b>
              <input
                disabled={disabled}
                value={editedCompanyNameViewProposal || ""}
                onChange={(e) =>
                  setEditedCompanyNameViewProposal(e.target.value)
                }
              />
            </p>
            <p className="d-flex align-items-center flex-grow-1">
              <b className="mx-1">Opportunity Owner :</b>

              <select
                id="signNames"
                name="signNames"
                autoComplete="off"
                onChange={(e) => {
                  const selectedItem = signatureNamesDB.find(
                    (item) => item.Id === e.target.value
                  );
                  setSignaturePersonInfo(selectedItem);
                }}
                disabled={isExistingBusiness()}
              >
                {signatureNamesDB.map((item) => (
                  <option key={item.Id} value={item.Id}>
                    {item.names}
                  </option>
                ))}
              </select>
            </p>
            <p className="d-flex align-items-center flex-grow-1">
              <b className="mx-1">Proposal # :</b>
              <input
                disabled={isExistingBusiness()}
                type="text"
                value={proposalNumber}
                onChange={(e) => {
                  const onlyNumbers = e.target.value.replace(/\D/g, "");
                  updateProposalNumber(onlyNumbers.slice(0, 12));
                }}
              />
            </p>
          </div>
        )}
        {companyNameError && (
          <div>
            {/* Your content here for when the word count exceeds 60 */}
            <p className={`${styles.dynamicName} dynamicName `}>
              Company name exceeds 48 characters.
            </p>
          </div>
        )}
        {!pricingTablesummaryDataLoader && (
          <>
            <div className={`${styles.tableContainer} tableContainer`}>
              {createPricingSummaryTable(data?.[selectedCarrier], styles)}
            </div>

            <div className="mt-5 mb-5">
              {sutaTypeMap?.peoStates?.length > 0 && (
                <p
                  className="fw-bold d-flex justify-content-center"
                  style={{ fontSize: "12px" }}
                >
                  *** {sutaTypeMap.peoStates.join(", ")} - Total Burden includes
                  Workers Compensation and Risk Management Administration (Bill
                  Rate) plus FICA/Medicare and FUTA ***
                </p>
              )}
              {sutaTypeMap?.clientStates?.length > 0 && (
                <p
                  className="fw-bold d-flex justify-content-center"
                  style={{ fontSize: "12px" }}
                >
                  *** {sutaTypeMap.clientStates.join(", ")} - States SUTA will
                  be calculated, reported and paid with clients SUTA
                  information, total burden rate above does not include SUTA ***
                </p>
              )}
            </div>
          </>
        )}

        {pricingTablesummaryDataLoader && (
          <div className="d-flex justify-content-center">
            <SmallLoader />
          </div>
        )}
      </div>
    </>
  );
};

export default React.memo(PricingTableSummary);
